<template src="./SubmitModal.html">
</template>

<script>
export default {
  name: "submit-modal",
  data() {
    return {
    };
  },
  props: {
    messages: {
      type: Array
    },
    title: {
      type: String,
    },
    loading: {
      type: Boolean
    },
    okClicked: {
      type: Function
    }
  },
  methods: {
    showSubmitModal() {
      this.$bvModal.show('submitModal');
    },
    hideSubmitModal() {
      this.$bvModal.hide('submitModal');
    },
    handleOk(modalEvent) {
      if (this.loading) {
        modalEvent.preventDefault();
      }

      this.okClicked();
    }
  },
};
</script>
